module.exports = __webpack_public_path__ + "images/sale_sticker@3x.png?d95f002e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale_sticker@3x.png
// module id = 694
// module chunks = 7